import { v4 } from 'uuid';
import {
  dispatchRequestInfo,
  executeTwoStepEventQueries,
  executeTwoStepEventQuery,
} from './execute';
import {
  buildComposeRevenueQueries,
  buildRevenueQueries,
  createCsvRevenueQuery,
  fromComposeRevenueResponse,
  fromRevenueCsvResponse,
  fromRevenueResponse,
  getComposeRevenueInfo,
  getRevenueCsvInfo,
  getRevenueInfo,
} from '../converters/revenueApiConverter';
import { downloadCsv } from '../utils/common';
import { TABS } from '../constants/navigation';

export const executeRevenueQueries = (executeId) => (dispatch, getState) => {
  const state = getState();
  const queries = buildRevenueQueries(state);
  const revenueInfo = getRevenueInfo(state);

  return executeTwoStepEventQueries(queries, executeId, dispatch, getState).then((response) =>
    fromRevenueResponse(response, queries, revenueInfo)
  );
};

export const executeComposeRevenueQueries = (executeId) => (dispatch, getState) => {
  const state = getState();
  const queries = buildComposeRevenueQueries(state);
  const composeRevenueInfo = getComposeRevenueInfo(state);

  return executeTwoStepEventQueries(queries, executeId, dispatch, getState).then((response) =>
    fromComposeRevenueResponse(response, queries, composeRevenueInfo)
  );
};

export const executeRevenueQueryCsv = () => (dispatch, getState) => {
  const state = getState();
  const query = createCsvRevenueQuery(state);
  const executeId = v4();
  const revenueCsvInfo = getRevenueCsvInfo(state);

  dispatchRequestInfo(executeId, dispatch, TABS.REVENUE.title, [query.eventName], true);

  return executeTwoStepEventQuery(query, executeId, dispatch, getState)
    .then((response) => fromRevenueCsvResponse(response, query, revenueCsvInfo))
    .then(downloadCsv);
};
